<div class="card tile" role="button" (click)="onTileClick()">

  <div class="tile-image-container">
    <au-thumbnail-image class="tile-image" [displayName]="tile.name" [size]="imageSize" [imageUrl]="tile.picture"
      [base64Picture]="tile.base64Picture"
      [imageClass]="tile.imageClass!" [defaultImageClass]="tile.defaultImageClass!" [key]="tile.key"
      [defaultImage]="tile.defaultImage">
    </au-thumbnail-image>
  </div>
  <div class="tile-title-container">
    <span class="tile-title text-center truncate">{{tile.name}}</span>
  </div>

</div>
